import { render } from "./HeadNavItem.vue?vue&type=template&id=4b8f476c"
import script from "./HeadNavItem.vue?vue&type=script&lang=js"
export * from "./HeadNavItem.vue?vue&type=script&lang=js"

import exportComponent from "D:\\20231109nkGg7QhS(1)\\20231109nkGg7QhS\\vueweb\\vue-antd-tool-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__